module.exports = __webpack_public_path__ + "media/images/browsers/mozilla-16276bda8b86298c44292b2c2c4bce7a.svg";